import script from "./LazyImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LazyImage.vue?vue&type=script&setup=true&lang=ts"

import "./LazyImage.vue?vue&type=style&index=0&id=3008c7c2&scoped=true&lang=css"

import exportComponent from "../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3008c7c2"]])

export default __exports__